// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-card__title{font-size:14px;font-weight:var(--1634e8x);line-height:20px;color:var(--1i0ph58);padding-right:3px;transition:color .3s ease-in-out}.media-card__title:hover{color:var(--11vpyxz)}.media-card__title--inside{position:absolute;left:5px;right:5px;bottom:10px;color:var(--1i0ph58);padding-right:3px}", ""]);
// Exports
module.exports = exports;
